import { combineReducers } from "redux";
import messageReducer from "../modules/shared/notification/slice";
import entitiesReducer from "../modules/shared/entity/slice";
import tripsReducer, { sliceName } from "../modules/trips/slice";
import authReducer from "../modules/auth/slice";
import fullPageLoaderReducer from "../modules/shared/FullPageLoader/slice";
import adminsSlice, { adminName } from "../modules/shared/Comments/slice";
import commentsSlice, { commentsList } from "../modules/shared/Comments/commentSlice";

export default combineReducers({
    entities: entitiesReducer,
    [sliceName]: tripsReducer,
    messages: messageReducer,
    auth: authReducer,
    fullPageLoader: fullPageLoaderReducer,
    [adminName]: adminsSlice,
    [commentsList]: commentsSlice,
});
